<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="COMPAÑIA" key="1">
          <g-master name="company"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    @action="masterAction"
                    :useMultipart="true"
                    :beforeSend="master.beforeSend"
                    modalWidth="90%"
          >
            <template slot="expandedRowRender" slot-scope="{text}">
              <template v-for="ve in master.valoresExpandidos">
                {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
              </template>
            </template>
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Id Compañía')">
                    <a-input
                      v-decorator="['id_company', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Compañía')">
                    <a-input
                      v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Código Compañía')">
                    <a-input
                      v-decorator="['code', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dirección Principal')">
                    <a-input
                      v-decorator="['address', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Nit')">
                    <a-input
                      v-decorator="['nit', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" label="Estado: " :has-feedback="false">
                    <a-checkbox
                      v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: true, message: 'Valor requerido' }]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dígito Verificación')">
                    <a-input
                      v-decorator="['digit', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Número de Cuenta')">
                    <a-input
                      v-decorator="['account_number', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Tipo de Cuenta')"
                              :formItemConfig="fiOptions"
                              :decorator="['account_type', { rules: [{ required: false}] }]"
                              :params="account_type"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="bank"
                              style="width: 100%"
                              :label="$t('Banco')"
                              :formItemConfig="fiOptions"
                              :decorator="['account_bank', { rules: [{ required: false}] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Id ubicación')">
                    <a-input
                      v-decorator="['id_ubication', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Dane ubicación')">
                    <a-input
                      v-decorator="['dane_ubication', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Pago de Contribución')" :has-feedback="false">
                    <a-checkbox
                      v-decorator="['contribution_payment', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                <a-form-item label="Registro comercial" v-bind="fiOptions">
                  <a-date-picker style="width: 100%"
                                 v-decorator="['commercial_register', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Id depto')">
                    <a-input
                      v-decorator="['department_id', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              style="width: 100%"
                              :label="$t('Entidad')"
                              :formItemConfig="fiOptions"
                              :selectedObj.sync="entidad"
                              :decorator="['ent_type', { rules: [{ required: false}] }]"
                              :params="ent_type"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-upload
                    name="logo_company"
                    :before-upload="(file) => beforeUpload(file, 'company')"
                    :fileList="master.uploads.logoCompany"
                    :remove="() => { master.uploads.logoCompany = [] }">
                    <a-button style="width: 100%">Logo compañia</a-button>
                  </a-upload>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-upload
                    name="logo_rh"
                    :before-upload="(file) => beforeUpload(file, 'rh')"
                    :fileList="master.uploads.logoRH"
                    :remove="() => { master.uploads.logoRH = [] }">
                    <a-button style="width: 100%">Logo RH</a-button>
                  </a-upload>
                </a-col>
              </a-row>
            </template>
          </g-master>
        </a-tab-pane>
      </a-tabs>
    </a-row>

    <a-row>
    </a-row>
  </div>
</template>

<script>
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        entidad: null,
        loadingBtns: {},
        loadingBtnsRh: {},
        ent_type: {
          h_lookup_type: 'TIPO_ENTIDAD',
          use_code: true
        },
        account_type: {
          h_lookup_type: 'TIPO_CUENTA',
          use_code: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'company',
          tableSetup: {
            tableConfig: {
              rowKey: 'id_company'
            },
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'download',
                  text: 'Descargar logo de la compañia',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.file_name_logo_le
                  },
                  fnLoading: (record) => {
                    return this.loadingBtns[record.id_company] === record.id_company
                  }
                },
                {
                  name: 'download_rh',
                  text: 'Descargar logo de rh',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'download', style: 'color: green'},
                  fnVisible: (record) => {
                    return record.file_name_logo_rh
                  },
                  fnLoading: (record) => {
                    return this.loadingBtnsRh[record.id_company] === record.id_company
                  }
                }
              ]
            },
            columns: [
              {title: 'Id compañia', dataIndex: 'id_company', sorter: true},
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Nit', dataIndex: 'nit', sorter: true},
              {title: 'Cuenta Bancaria', dataIndex: 'account_bank', sorter: true},
              {title: 'Número de Cuenta', dataIndex: 'account_number', sorter: true},
              {title: 'Tipo de cuenta', dataIndex: 'account_type', sorter: true},
              {title: 'Direcciòn', dataIndex: 'address', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ],
            customSlots: ['expandedRowRender']
          },
          valoresExpandidos: [
            {label: 'Registro Comercial', column: 'commercial_register_mask'},
            {label: 'Pago de Contribución', column: 'contribution_payment_desc'},
            {label: 'Ubicación Dane', column: 'dane_ubication'},
            {label: 'Id Departamento', column: 'department_id'},
            {label: 'Digito', column: 'digit'},
            {label: 'ent_id', column: 'ent_id'},
            {label: 'Entidad', column: 'ent_type'},
            {label: 'ID Ubicacion', column: 'id_ubication'},
            {label: 'Codigo', column: 'code'}
          ],
          modalFieldsSetup: [
            {name: 'account_bank'},
            {name: 'account_number'},
            {name: 'account_type'},
            {name: 'address'},
            {name: 'code'},
            {name: 'commercial_register', type: 'date'},
            {name: 'contribution_payment'},
            {name: 'created_by'},
            {name: 'created_on'},
            {name: 'dane_ubication'},
            {name: 'department_id'},
            {name: 'digit'},
            {name: 'ent_id'},
            {name: 'ent_name'},
            {name: 'ent_nit'},
            {name: 'ent_type'},
            {name: 'file_name_logo_le'},
            {name: 'file_name_logo_rh'},
            {name: 'file_path_logo_le'},
            {name: 'file_path_logo_rh'},
            {name: 'id_company'},
            {name: 'id_ubication'},
            {name: 'logo_le'},
            {name: 'logo_rh'},
            {name: 'modified_by'},
            {name: 'modified_on'},
            {name: 'name'},
            {name: 'nit'},
            {name: 'status'}
          ],
          uploads: {
            logoCompany: [],
            logoRH: []
          },
          beforeSend: (data) => {
            if (this.master.uploads.logoCompany.length > 0) {
              data.logoCompany = this.master.uploads.logoCompany[0]
            }
            if (this.master.uploads.logoRH.length > 0) {
              data.logoRH = this.master.uploads.logoRH[0]
            }
            return data
          }
        }
      }
    },
    methods: {
      masterAction (action) {
        if (action.action === 'masterCreate' || action.action === 'masterEdit') {
          this.master.uploads.logoCompany = []
          this.master.uploads.logoRH = []
        }
        switch (action.action) {
          case 'download':
            this.downloadFile(action.record, 'logo_company')
            break
          case 'download_rh':
            this.downloadFile(action.record, 'logo_rh')
            break
        }
      },
      downloadFile (record, logo) {
        if (logo === 'logo_company') {
          this.loadingBtns[record.id_company] = record.id_company
          this.loadingBtns = Object.assign({}, this.loadingBtns)
        } else {
          this.loadingBtnsRh[record.id_company] = record.id_company
          this.loadingBtnsRh = Object.assign({}, this.loadingBtnsRh)
        }

        this.httpClient.getInstance().post('company/download', {
          id_company: record.id_company,
          logo: logo
        }, {responseType: 'arraybuffer'}).then((response) => {
          let fileURL = new Blob([response.data], {type: 'application/octet-stream'})
          fileURL = window.URL.createObjectURL(fileURL)
          let fileLink = document.getElementById('file_link_elm')
          if (fileLink === null) {
            fileLink = document.createElement('a')
            fileLink.setAttribute('id', 'file_link_elm')
            document.body.appendChild(fileLink)
          }

          fileLink.setAttribute('href', fileURL)
          fileLink.setAttribute('download', response.headers['x-nombre-archivo'])
          fileLink.click()
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible descargar el archivo.')
        }).then(() => {
          delete this.loadingBtns[record.id_company]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
          delete this.loadingBtnsRh[record.id_company]
          this.loadingBtnsRh = Object.assign({}, this.loadingBtnsRh)
        })
      },
      beforeUpload (file, campo) {
        if (this.validateFile(file)) {
          if (campo === 'company') {
            this.master.uploads.logoCompany = [file]
          } else {
            this.master.uploads.logoRH = [file]
          }
        }
        return false
      },
      validateFile (file) {
        const typeMime = ['gif', 'png', 'jpeg', 'jpg']
        let ext = file.type.split('/')[1]
        if (!typeMime.includes(ext)) {
          this.$message.error('Solo se pemiten archivos de extensión ' + typeMime.toString())
          return false
        }
        const isLt2M = file.size / 1024 / 1024 < 2
        if (!isLt2M) {
          this.$message.error('El tamaño del archivo no puede ser mayor a 2 Megas.')
          return false
        }
        return true
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Company/Company.vue